<template>
  <accordion-group class="product-details" ref="accordion-group">
    <accordion ref="product-details-accordion" id="product-details-accordion" v-if="product.description" :expand-max-height="3000" iconSize="9px" :auto-close="false" theme="product-details">
      <span class="product-details__heading" slot="heading">Product Details</span>
      <accordion-tease class="product-details__tease" :on-tease-expand="onTeaseExpand" :collapsed-height="314">
        <div class="product-details__description client-generated" v-html="product.description"></div>
      </accordion-tease>
    </accordion>

    <accordion v-if="customFields['show_additional_details_accord'] && customFields['optional_body_copy']" theme="product-details" :auto-close="false" :expand-max-height="2000" iconSize="9px" heading="More Information">
      <span class="product-details__heading" slot="heading">Key Benefits</span>
      <accordion-tease class="product-details__tease" :on-tease-expand="onTeaseExpand" :collapsed-height="314">
        <div class="product-details__optional-body-copy client-generated" v-if="customFields['optional_body_copy']" v-html="customFields['optional_body_copy']"></div>
        <v-link secondary="secondary" v-if="customFields['link_text'] && customFields['link_url']" :href="customFields['link_url']">{{ customFields['link_text'] }}</v-link>
      </accordion-tease>
    </accordion>

    <accordion theme="product-details" :auto-close="false" v-if="settings.accordionContent">
      <span class="product-details__heading" slot="heading">{{ settings.accordionName }}</span>
      <accordion-tease class="product-details__tease" :on-tease-expand="onTeaseExpand" :collapsed-height="314">
        <div class="client-generated" v-html="settings.accordionContent"></div>
      </accordion-tease>
    </accordion>

    <accordion id="product-brand-accordion" iconSize="9px" :auto-close="false" v-if="brand && brand.about_the_brand" heading="Brand Information">
      <span class="product-details__heading" slot="heading">{{ aboutTitle }}</span>
      <accordion-tease class="product-details__tease" :on-tease-expand="onTeaseExpand" :collapsed-height="314">
        <div class="client-generated">
          <p>
            <span v-html="brand.about_the_brand"></span>
            <a class="shop-all-link"
               :href="aboutLink">{{ aboutLinkText }}</a>
          </p>
        </div>
      </accordion-tease>
    </accordion>
  </accordion-group>
</template>

<script>
import AccordionGroup from '@/scripts/components/basic/AccordionGroup.vue'
import Accordion from '@/scripts/components/basic/Accordion.vue'
import AccordionTease from '@/scripts/components/basic/AccordionTease.vue'
import Icon from '@/scripts/components/basic/Icon.vue'
import VLink from '@/scripts/components/buttons/VLink.vue'

export default {
  name: 'ProductDetails',
  components: {
    AccordionGroup,
    Accordion,
    VLink,
    AccordionTease,
    Icon
  },
  props: {
    collection: Object,
    product: Object,
    customFields: Object,
    settings: Object,
    brand: Object,
  },
  methods: {
    onTeaseExpand () {
      // tell the active accordions to update their height
      this.$refs['accordion-group'].accordions.filter(a => a.active)
        .forEach(a => a.setContentHeight())
    }
  },
  computed: {
    aboutTitle () {
      if (this.brand['pdp_-_about_the_brand_title']) return this.brand['pdp_-_about_the_brand_title'];
      return 'About the Brand';
    },
    aboutLink () {
      if (this.brand['pdp_about_the_brand_url']) return this.brand['pdp_about_the_brand_url'];
      return `/collections/${this.customFields.brand_name.toLowerCase().replaceAll(' ', '-')}`;
    },
    aboutLinkText () {
      if (this.brand['pdp_about_the_brand_cta_text']) return this.brand['pdp_about_the_brand_cta_text'];
      return `Shop All ${this.customFields.brand_name}`;
    },
  },
}
</script>

<style lang="scss" scoped>
  .product-details {
    margin-top: rem(18);

    @include desktop-up {
      margin-top: rem(20);
    }

    &__heading {
      font-family: $font-family-primary;
      font-size: rem(15);
      line-height: rem(22);
      color: $color-black-900;
      font-weight: 400;
    }

    &__optional-body-copy {
      margin-bottom: 12px;
    }

    &__table {
      border-collapse: collapse;
      margin: $grid-gutter 0;
    }

    &__table-row {
      width: 100%;
      border-top: 1px solid $color-lightest-grey;

      &:last-child {
        border-bottom: 1px solid $color-lightest-grey;
      }

      &:nth-child(odd) {
        background-color: #F8F8F8;
      }
    }

    &__download {
      margin-top: 20px;

      .link {
        line-height: inherit;
      }

      svg {
        margin-right: 8px;
        display: inline-block;
      }

      &:hover svg {
        fill: $color-brand-primary;
      }
    }

    /deep/ .accordion {
      border-top: 1px solid $color-black-500;
      border-bottom: 1px solid $color-black-500;

      .client-generated p {
        @include body-sm;
      }

      + .accordion {
        border-top: none !important;
      }

      .accordion__content {
        padding: 0 0 12px 0;
        @include mobile-only {
          padding: 0 8px 12px 8px;
        }
      }

      .accordion__header {
        padding: 14px 0;
        transition: background-color .2s linear;
        @include mobile-only {
          padding: 12px 8px;
        }
      }

      @include mobile-only {
        &:first-child {
          margin-top: 20px;
          border-top: 1px solid $color-black-500;
        }
      }
    }

    /deep/ .accordion.is-open  {
      border-bottom: 1px solid $color-black-500;

      .accordion__header {
        border-bottom: transparent;
      }
    }

    /deep/ .accordion__header.is-open + .accordion__content .show-more__overlay {
      background: linear-gradient(180deg, rgba(250, 251, 250, 0) 0%, rgba($color-white, .98) 86%, rgba($color-white, 1) 100%);
    }

    /deep/ &__tease .show-more__button {
      text-decoration: underline;
      font-size: 11px;

      &:after, &:before {
        display: none;
      }
    }
  }

  .shop-all-link {
    display: inline-block;
    margin-left: 5px;
  }
</style>
